import React, { KeyboardEvent, MouseEvent } from "react";
import styles from "./ota-secondary-button.module.scss";
import { ToolTip } from "@components/atoms/tooltip/tooltip";

type OTASecondaryButtonPropTypes = {
  fun: (e: MouseEvent | KeyboardEvent) => void;
  text: string;
  disabled?: boolean;
  tooltip?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const OTASecondaryButton = ({
  fun,
  text,
  disabled = false,
  tooltip = "",
  children,
  ...rest
}: OTASecondaryButtonPropTypes) => {
  const button = (
    <button
      disabled={disabled}
      onClick={fun}
      className={styles.button}
      {...rest}
    >
      {children ?? text}
    </button>
  );

  return tooltip ? <ToolTip content={tooltip}>{button}</ToolTip> : button;
};
